import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { StyledButton } from 'components/shared'

export default function MediaLinks() {
  return (
    <section className="bg-black py-4">
      <div className="w-11/12 mx-auto container grid grid-cols-1 gap-12 pb-12">
        <div className="mx-auto text-center space-y-5 md:w-full md:flex md:items-center md:justify-between md:gap-20 md:text-left md:text-[20px] md:max-w-[750px] md:space-y-0">
          <div className="w-[210px] mx-auto lg:w-[300px] md:m-0 md:max-w-[280px]">
            <StaticImage src="../../../images/logos/playbill.png" alt="" />
          </div>
          <div className="md:w-[400px]">
            <p>
              <strong>
                SONGS FROM <br />
                DOROTHY DANDRIDGE! THE MUSICAL
              </strong>
            </p>
            <StyledButton
              text="Read more"
              outbound
              href="https://playbill.com/production/the-songs-of-dorothy-dandridge-the-musical-off-broadway-carnegie-hall-2022"
              target="_blank"
              rel="noopener noreferrer"
            />
          </div>
        </div>
        <div className="mx-auto text-center space-y-5 md:w-full md:flex md:items-center md:justify-between md:gap-20 md:text-left md:text-[20px] md:max-w-[750px] md:space-y-0">
          <div className="w-[174px] mx-auto lg:w-[280px] md:m-0 md:max-w-[280px]">
            <StaticImage
              src="../../../images/logos/broadway-world.png"
              alt=""
            />
          </div>
          <div className="md:w-[400px]">
            <p className="mt-5">
              <strong>MEET THE COMPANY</strong>
            </p>
            <StyledButton
              text="Read more"
              outbound
              href="https://www.broadwayworld.com/off-off-broadway/article/Photos-Meet-The-Company-Of-THE-SONGS-OF-DOROTHY-DANDRIDGE-THE-MUSICAL-20220714"
              target="_blank"
              rel="noopener noreferrer"
            />
            <p className="mt-5">
              <strong>
                PHOTOS INSIDE THE TWO NIGHT <br className="hidden md:block" />{' '}
                PRESENTATION
              </strong>
            </p>
            <StyledButton
              text="Read more"
              outbound
              href="https://www.broadwayworld.com/off-off-broadway/article/Photos-Inside-the-Two-night-Presentation-Of-THE-SONGS-OF-DOROTHY-DANDRIDGE-THE-MUSICAL-at-Carnegie-Hall-20220809"
              target="_blank"
              rel="noopener noreferrer"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
